export function getOneConversationPrompt(salesAnswer: string, customerAnswer: string): string {
  return `
  
    Customer: ${customerAnswer}
  
    Sales rep: ${salesAnswer}
    `;
}
